import { render, staticRenderFns } from "./webAiVoiceCase.vue?vue&type=template&id=62cb331a&scoped=true&"
import script from "./webAiVoiceCase.vue?vue&type=script&lang=js&"
export * from "./webAiVoiceCase.vue?vue&type=script&lang=js&"
import style0 from "./webAiVoiceCase.vue?vue&type=style&index=0&id=62cb331a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb331a",
  null
  
)

export default component.exports